import { Text } from '@mantine/core';

import { formatDueDate } from '@/utils';

/**
 * Table cell for the Due column on the Reports / Requests lists: the
 * computed due date once screening has started, else the agreed TAT
 * (dimmed) so the row still answers "how long", else an em dash.
 */
export function DueCell({
  dueAt,
  turnaroundTimeDays,
}: Readonly<{ dueAt: string | null; turnaroundTimeDays: number | null }>) {
  if (dueAt) {
    return <Text size="sm">{formatDueDate(dueAt)}</Text>;
  }
  if (turnaroundTimeDays != null) {
    return (
      <Text size="sm" c="dimmed">
        {turnaroundTimeDays}d TAT
      </Text>
    );
  }
  return (
    <Text size="sm" c="dimmed">
      —
    </Text>
  );
}
